import { FC } from "react";
import { useTranslation } from "react-i18next";

import { Info } from "@/assets/icons/icons";

// this is a banner component, which renders permantly fixed at the top of the page
export const AgentLoginBanner: FC = () => {
  const { t } = useTranslation();

  return (
    <div className="fixed left-0 right-0 top-0 z-[100] h-10 w-full bg-primary-25">
      <div className="flex flex-row py-2">
        <div className="m-auto flex flex-row text-primary-100">
          <Info className="mr-2 h-6 w-6" />
          <p>{t("portal:common.alerts.agentLogin")}</p>
        </div>
      </div>
    </div>
  );
};
